module.exports = __webpack_public_path__ + "img/slide-1.2aa7c930.png";